package ui.external.materialui

object Position {
    const val fixed = "fixed"
}
